export default __webpack_public_path__ + "media/images/logo-ae1e1f58001d7747612e33ed7cc6f25a.png";